import React, { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { useVisualizacao } from '../../VisualizacaoContext';
import {
  FormActionsContainer,
  ButtonsContainer,
  SelectWrapper,
} from './styles';
import { OptionsViewProps } from '../../types';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

/**
 * FormActions
 * @description
 * Ações do formulário de Visualizações:
 * - Selecionar/criar visualização via combobox com criação inline.
 * - Mantém a experiência do Atlaskit usando react-select/creatable.
 * - Regras de UX originais preservadas (Enter, mensagens, UPPERCASE + limite 50).
 */
export const FormActions: React.FC = () => {
  const [inputvalue, setinputvalue] = useState<string>('');
  const [optionsWithoutPadrao, setOptionsWithoutPadrao] = useState<
    OptionsViewProps[]
  >([]);

  const {
    selectedOptionView,
    optionsViews,
    onCreateView,
    handleChangeView,
    handleSubmit,
    handleClear,
    handleDelete,
    isUpdate,
    setIsChangeView,
    btnSalvarBlock,
  } = useVisualizacao();

  useEffect(() => {
    if (optionsViews.length > 0) {
      setOptionsWithoutPadrao(
        optionsViews.filter((option) => option.value !== -1),
      );
    }
  }, [optionsViews]);

  return (
    <FormActionsContainer>
      <SelectWrapper>
        <CreatableSelect<OptionsViewProps, false>
          // Acessibilidade e classes para customização
          inputId="view-select"
          className="view-select"
          classNamePrefix="view-select"
          // Mensagem ao criar
          formatCreateLabel={(userInput: string) =>
            `TOQUE AQUI para criar a visualização '${userInput.toUpperCase()}'`
          }
          // Controle do input (UPPERCASE + limite 50)
          inputValue={inputvalue}
          onInputChange={(value) => {
            const next = value.toUpperCase().slice(0, 50);
            setinputvalue(next);
            return next;
          }}
          placeholder="Digite um nome para Cadastro ou Selecione uma Visualização"
          noOptionsMessage={() => 'Nenhum Registro Encontrado'}
          // Dados
          value={selectedOptionView as OptionsViewProps | null}
          options={optionsWithoutPadrao}
          // Seleção/criação
          onChange={(opt) =>
            handleChangeView((opt ?? null) as OptionsViewProps | null)
          }
          onCreateOption={onCreateView}
          onKeyDown={(ev) => {
            if (ev.key === 'Enter' && !selectedOptionView) {
              ev.preventDefault();
              ev.stopPropagation();
              setTimeout(() => {
                setIsChangeView(false);
              }, 200);
            }
          }}
          // Estilo e portal do menu para evitar sobreposição
          styles={{
            container: (base) => ({ ...base, width: '100%' }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPortalTarget={
            typeof window !== 'undefined' ? document.body : null
          }
        />
      </SelectWrapper>

      <ButtonsContainer>
        <CustomButtonNovo
          onClick={handleSubmit}
          disabled={!selectedOptionView || btnSalvarBlock}
          variant="confirm"
          label="Salvar"
        />

        <CustomButtonNovo
          onClick={() => {
            handleClear();
          }}
          disabled={!selectedOptionView}
          style={{ marginLeft: '0px' }}
          variant="clear"
          label="Limpar"
        />

        <CustomButtonNovo
          onClick={handleDelete}
          disabled={!isUpdate || !selectedOptionView}
          variant="error"
          label="Excluir"
        />
      </ButtonsContainer>
    </FormActionsContainer>
  );
};
